import React from "react";

export default function ToggleInput({
  label,
  checked,
  onChange,
  labelStyle,
  type,
  id = "recommend-tag",
}) {
  return (
    <div
      className={`d-flex align-items-center e-w-fit column-gap-2 ${
        type === 2 || 3 ? "flex-row-reverse " : ""
      }`}
    >
      <label
        htmlFor={id}
        style={{ height: type === 3 ? 15 : 17, width: type === 3 ? 28 : 32 }}
        className={`d-flex e-cursor-pointer position-relative px-3 rounded-pill e-border-1px-silver e-transition-100ms ${
          checked
            ? "e-bg-toggle-gradient-check"
            : "e-bg-toggle-gradient-uncheck"
        }`}
      >
        <span
          style={{
            height: type === 3 ? 10 : 14,
            width: type === 3 ? 10 : 14,
            transform: checked ? "translateX(0px)" : "translateX(-15px)",
          }}
          className="bg-white e-transition-100ms e-cursor-pointer rounded-circle align-self-center position-absolute e-border-1px-silver"
        ></span>

        <input
          id={id}
          type="checkbox"
          className="opacity-0 visually-hidden"
          checked={checked}
          onChange={() => onChange((prev) => !prev)}
        />
      </label>

      <span className={`m-0 ${labelStyle}`}>{label}</span>
    </div>
  );
}
